<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                        <div class="returnNavBarRight">
                            <span @click="handleClickBatch">批量操作</span>
                        </div>
                    </div>
                    <div class="top_search">
                        <van-search
                            v-model="searchForm.keyword"
                            placeholder="请输入查询内容"
                            @search="onSearch"
                            @clear="onSearch"
                        >
                            <template #right-icon>
                                <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                            </template>
                        </van-search>
                    </div>
                    <div class="all_menu_list">
                        <ul>
                            <li
                                v-for="item in sourceList"
                                :key="item.id"
                                :class="{ active: source_id == item.id }"
                                @click="handleClickTypeChange(item)"
                            >
                                <span>{{ item.name }}</span>
                                <i class="count" v-if="item.count">{{ item.count > 99 ? "99+" : item.count }}</i>
                            </li>
                        </ul>
                        <div class="all_menu_filter_icon" @click="handleClickCategoryPickerShow">
                            <img
                                src="https://download.hecoos.com/enlightv/2024-51/4c642c0c14402f868ad37bc896bb25fb.png"
                                alt=""
                            />
                        </div>
                    </div>
                    <div class="status_wrap">
                        <div>
                            <span
                                v-for="status in statusList"
                                :key="status.value"
                                :class="{ active: status.value === tabActiveName }"
                                @click="handleClickStatusChange(status)"
                                >{{ status.name }}</span
                            >
                        </div>
                        <span>{{ pagination.total }}条</span>
                    </div>
                    <div class="mobile_container payable_management_container">
                        <div class="mobile_container_list">
                            <ul v-infinite-scroll="onLoadList">
                                <li class="payable_list_item" v-for="(row, index) in tableData" :key="index" @click.stop="handleClickDetail(row)">
                                    <div class="payable_list_item_top">
                                        <div class="mobile_list_head_user" @click.stop="handleClickUserInfo(row.uid_info)">
                                            <img :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg" alt="" />
                                            <span class="ellipsis">{{ row.uid_info && row.uid_info.name }}</span>
                                        </div>
                                        <span class="payable_list_item_top_time">{{ tabActiveName == 1 ? row.created_at : ( tabActiveName == 2 ? row.payment_time : row.cancel_time)}}</span>
                                        <span
                                            class="payable_list_item_status"
                                            :class="'payable_list_item_status' + row.payment_status"
                                            >{{ getStatusName(row.payment_status) }}</span
                                        >
                                    </div>
                                    <div class="payable_list_item_content">
                                        <template v-if="row.source_type == 'purchase'">
                                            <p>
                                                <span
                                                    class="link-label"
                                                    @click.stop="handleClickRelateId(row.relate_id)"
                                                    >{{ row.detail && row.detail.purchase_no }}</span
                                                >
                                            </p>
                                            <p>
                                                {{
                                                    row.detail && row.detail.supplier_name
                                                        ? row.detail.supplier_name
                                                        : "--"
                                                }}
                                            </p>
                                        </template>
                                        <template v-else-if="row.source_type == 'order_return'">
                                            <p>
                                                <span
                                                    class="link-label"
                                                    @click.stop="
                                                        handleClickOrderDetail(row.detail && row.detail.order_no)
                                                    "
                                                    >{{ row.detail && row.detail.order_no }}</span
                                                >
                                            </p>
                                            <p>
                                                <span
                                                    class="link-label"
                                                    @click.stop="
                                                        handleClickCustomerDetail(
                                                            row.customer_info && row.customer_info.id,
                                                            row.customer_info && row.customer_info.name
                                                        )
                                                    "
                                                    >{{ (row.customer_info && row.customer_info.name) || "--" }}</span
                                                >
                                            </p>
                                        </template>
                                        <p v-else>
                                            {{ row.detail && row.detail.payee_name ? row.detail.payee_name : "--" }}
                                        </p>
                                        <div class="payable_list_item_amount">
                                            <div>
                                                <div class="payable_list_item_amount_percent percent_bg1">
                                                    应付金额：¥{{ row.payable_amount }}
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    class="payable_list_item_amount_percent percent_bg2"
                                                    v-if="row.payment_status !== 1"
                                                >
                                                    已付金额：¥{{ row.paid_amount }}
                                                </div>
                                                <div
                                                    class="payable_list_item_amount_percent percent_bg3"
                                                    v-if="row.payment_status == 1 || row.payment_status == 4"
                                                >
                                                    未付金额：¥{{ row.unpaid_amount }}
                                                </div>
                                                <div
                                                    class="payable_list_item_amount_percent percent_bg3"
                                                    v-if="row.payment_status == 3"
                                                >
                                                    取消付款金额：¥{{ row.unpaid_amount }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="payable_list_item_bottom"
                                        v-if="row.payment_status == 1 || row.payment_status == 4"
                                    >
                                        <van-button
                                            plain
                                            size="mini"
                                            color="#333333"
                                            class="custom_default_btn"
                                            @click.stop="handleClickCancelPayment(row)"
                                            >取消付款</van-button
                                        >
                                        <van-button size="mini" color="#2990FF" @click.stop="handleClickPayment(row)"
                                            >付款</van-button
                                        >
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                    <!-- 应付菜单类型选择 -->
                    <van-overlay
                        :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                        class-name="custom_more_overlay"
                        v-if="showCategoryPicker"
                        :show="showCategoryPicker"
                        @click="showCategoryPicker = false"
                    >
                        <div class="radio_option_wrap">
                            <div class="radio_option_item" @click="handleClickCategoryPickerClose">
                                <span>应付分类</span>
                                <van-icon name="arrow-up" />
                            </div>
                            <ul class="radio_option_list">
                                <li
                                    class="radio_option_item"
                                    v-for="item in sourceList"
                                    :key="item.id"
                                    @click="handleClickTypeChange(item)"
                                >
                                    <span>{{ item.name }}</span>
                                    <van-icon name="success" v-if="source_id == item.id" />
                                </li>
                            </ul>
                        </div>
                    </van-overlay>
                    <!-- 取消付款 -->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" :show="cancelPaymentDialog">
                        <div class="custom_overlay_content">
                            <div class="custom_overlay_content_title">
                                <span>取消付款</span>
                                <van-icon name="cross" @click="handleClickCancelPaymentClose" />
                            </div>
                            <div class="custom_overlay_content_form">
                                <van-field
                                    v-model="cancelRemarks"
                                    rows="6"
                                    autosize
                                    label=""
                                    type="textarea"
                                    placeholder="请输入取消原因"
                                />
                                <van-button color="#2990FF" @click="handleClickCancelPaymentConfirm">确定</van-button>
                            </div>
                        </div>
                    </van-overlay>
                </div>
            </template>
        </PullContainer>
        <userDetailDialog
            v-if="userDetailPopupShow"
            :userDetailPopupShow.sync="userDetailPopupShow"
            :userId="userDetailId"
        />
        <ListAdvancedFiltering
            v-if="searchPopupShow"
            ref="listAdvancedFiltering"
            :system_fields.sync="systemFilterFields"
            @sendFilterData="getFilterData"
        />
    </div>
</template>
<script>
import { PayableSourceList, PayableList, PayableCancel, PayableBatchCancel } from "@/api";
import { pagination } from "@/mixins";
import { mapState } from "vuex";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import ListAdvancedFiltering from "../component/ListAdvancedFiltering.vue";
import payableStatistics from "./payable_statistics.vue";
export default {
    name: "PayableManage",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        userDetailDialog,
        ListAdvancedFiltering,
        payableStatistics,
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            searchForm: {
                keyword: "",
            },
            source_id: "purchase", // 来源id
            source_type: "purchase", // 来源类型
            sourceList: [],
            showCategoryPicker: false,
            tabActiveName: "1",
            statusList: [
                { value: "1", name: "待付款" },
                { value: "2", name: "已付款" },
                { value: "3", name: "已取消" },
            ],
            tableData: [],
            // 取消付款
            cancelPaymentDialog: false,
            cancelRemarks: "",
            handleDialogIds: [],
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "FinanceManagement",
                    title: "首页",
                },
                {
                    icon: "icon-mobile-yingfu",
                    activeIcon: "icon-mobile-yingfu",
                    routerName: "PayableManage",
                    title: "应付",
                },
                {
                    icon: "icon-yingshou",
                    activeIcon: "icon-yingshouxuanzhong",
                    routerName: "ReceivableManage",
                    title: "应收",
                },
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "InvoiceManage",
                    title: "开票",
                },
            ],
            tabBarActive: 1,
            custom_filter: {}, // 高级筛选确认条件
            // 人员详细信息
            userDetailPopupShow: false,
            userDetailId: "",
            showStatistics: false,
        };
    },
    mixins: [pagination],
    computed: {
        ...mapState(["searchPopupShow"]),
        systemFilterFields() {
            return [
                {
                    field_type: "contact",
                    field_key: "uid",
                    is_system: 1,
                    field_name: "申请人",
                    system_type: "system",
                    field_value_type: "int",
                },
                {
                    field_type: "date_range",
                    field_key: "apply_time_range",
                    is_system: 1,
                    field_name: "创建时间",
                    system_type: "system",
                    field_value_type: "array",
                },
                {
                    field_type: "checkbox",
                    field_key: "filter_payment_status",
                    is_system: 1,
                    field_name: "付款状态",
                    system_type: "system",
                    field_value_type: "int",
                    options: this.paymentStatusOptions,
                },
            ];
        },
        paymentStatusOptions() {
            if (this.tabActiveName == 1) {
                return [
                    { value: 1, label: "待付款" },
                    { value: 4, label: "部分付款" },
                ];
            } else if (this.tabActiveName == 2) {
                return [
                    { value: 2, label: "已付款" },
                    { value: 4, label: "部分付款" },
                ];
            } else {
                return [{ value: 3, label: "已取消" }];
            }
        },
    },
    created() {
        this.getPayableSourceList();
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onSearch();
            }
        },
        // 应付来源
        getPayableSourceList() {
            PayableSourceList().then((res) => {
                if (res.code === 200) {
                    this.sourceList = res.data || [];
                    this.sourceList.push({ name: "应付统计", source_type: "", type: "statistics" });
                    if (this.sourceList.length) {
                        this.source_type = this.sourceList[0].source_type || "";
                        this.source_id = this.sourceList[0].id || "";
                    }
                    this.$nextTick(() => {
                        this.onSearch();
                    });
                }
            });
        },
        getStatusName(status) {
            let label = "";
            status = String(status);
            switch (status) {
                case "1":
                    label = "待付款";
                    break;
                case "2":
                    label = "已付款";
                    break;
                case "3":
                    label = "已取消";
                    break;
                case "4":
                    label = "部分付款";
                    break;
            }
            return label;
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.$store.dispatch("searchPopupShow", false);
            this.onSearch();
        },
        // 分类切换
        handleClickCategoryPickerShow() {
            this.showCategoryPicker = true;
        },
        // 类型切换
        handleClickTypeChange(item) {
            this.searchForm.keyword = ""
            if (this.custom_filter.custom_field && this.custom_filter.custom_field.length) {
                this.custom_filter.custom_field.forEach((option) => {
                    this.$set(item, "field_value", option.field_value_type == "int" ? [] : "")
                });
            }
            if (item.type && item.type == "statistics") {
                // 统计
                this.source_id = "";
                this.showStatistics = true;
                this.$router.push({
                    name: "PayableStatistics",
                });
            } else {
                this.source_id = item.id;
                this.showCategoryPicker = false;
                this.tabActiveName = "1";
                this.onSearch();
            }
        },
        handleClickCategoryPickerClose() {
            this.showCategoryPicker = false;
        },
        // 状态切换
        handleClickStatusChange(status) {
            this.tabActiveName = status.value;
            this.searchForm.keyword = ""
            if (this.custom_filter.custom_field && this.custom_filter.custom_field.length) {
                this.custom_filter.custom_field.forEach((option) => {
                    this.$set(item, "field_value", option.field_value_type == "int" ? [] : "")
                });
            }
            this.onSearch();
        },
        // 取消付款
        handleClickCancelPayment(row) {
            this.handleDialogType = "cancelPay";
            this.handleDialogIds = [row.payable_no];
            this.cancelPaymentDialog = true;
        },
        // 取消付款弹框关闭
        handleClickCancelPaymentClose() {
            this.handleDialogType = "";
            this.handleDialogIds = [];
            this.cancelRemarks = "";
            this.cancelPaymentDialog = false;
        },
        // 取消付款确认
        handleClickCancelPaymentConfirm() {
            if (!this.cancelRemarks) return this.$toast("请填写取消原因");
            if (this.handleDialogType === "cancelPay") {
                // 单个取消
                PayableCancel({ payable_no: this.handleDialogIds[0], cancel_reason: this.cancelRemarks }).then(
                    (res) => {
                        if (res.code == 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.handleClickCancelPaymentClose();
                                    this.onSearch();
                                },
                            });
                        } else {
                            this.$message.error(res.message);
                        }
                    }
                );
            } else {
            }
        },
        // 付款
        handleClickPayment(row) {
            this.$router.push({
                name: "PayablePayment",
                query: {
                    payable_no: row.payable_no,
                    type: "payment",
                },
            });
        },
        // 详情
        handleClickDetail(row) {
            this.$router.push({
                name: "PayableDetails",
                query: {
                    payable_no: row.payable_no,
                },
            });
        },
        // 批量操作
        handleClickBatch() {
            this.$router.push({
                name: "PayableChoose",
                query: {
                    source_id: this.source_id,
                    payment_status: this.tabActiveName,
                },
            });
        },
        // 人员详细信息
        handleClickUserInfo(info) {
            this.userDetailId = info.id;
            this.userDetailPopupShow = true;
        },
        onSearch() {
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getTableData();
        },
        // 加载更多
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            let params = {
                source_id: this.source_id,
                payment_status: this.tabActiveName,
                page: this.pagination.pageNum,
                pageSize: 10, // this.pagination.pageSize
                keyword: this.searchForm.keyword,
            };
            if (this.custom_filter.custom_field && this.custom_filter.custom_field.length) {
                this.custom_filter.custom_field.forEach((option) => {
                    params[option.field_key] =
                        option.field_value_type == "int" ? option.field_value[0] : option.field_value;
                });
            }
            PayableList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.$router.push({
                name: "purchase_detail",
                query: {
                    purchase_id: purchaseId,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(order_no) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: order_no,
                    name: order_no,
                    query_type: "order_no",
                },
            });
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.returnNavBarRight {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(41, 144, 255, 1);
}

.all_menu_list {
    margin-top: -4px;
    height: 42px;
    opacity: 1;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;

    ul {
        height: 100%;
        padding: 0 7px 0 16px;
        overflow-x: auto;
        display: flex;
        gap: 10px;

        li {
            flex: auto;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 42px;
            color: rgba(102, 102, 102, 1);
            text-align: center;
            white-space: nowrap;
            position: relative;

            span {
                line-height: 22px;
            }

            &.active {
                font-weight: 700;
                color: rgba(25, 144, 255, 1);

                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    margin-left: -10px;
                    width: 20px;
                    height: 2px;
                    border-radius: 1px 1px, 0px, 0px;
                    background: rgba(41, 144, 255, 1);
                }
            }

            .count {
                position: absolute;
                top: 5px;
                right: 1px;
                padding: 0 4px;
                min-width: 18px;
                height: 18px;
                line-height: 16px;
                text-align: center;
                border: 1px solid #ffffff;
                font-size: 10px;
                font-weight: 500;
                color: #ffffff;
                border-radius: 10px;
                background-color: rgb(228, 65, 68);
            }
        }
    }

    .all_menu_filter_icon {
        flex-shrink: 0;
        padding: 0 16px;

        img {
            width: 16px;
        }
    }
}

.radio_option_wrap {
    width: 100%;
    min-height: 220px;
    max-height: 50%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;

    .radio_option_item {
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
        }

        .van-icon {
            color: rgba(51, 51, 51, 1);
            font-size: 12px;
        }
    }

    .radio_option_list {
        flex: 1;
        overflow-y: auto;

        .radio_option_item {
            span {
                color: rgba(102, 102, 102, 1);
            }

            .van-icon {
                color: rgba(25, 144, 255, 1);
            }
        }
    }
}

.custom_more_overlay {
    top: 44px !important;
}

.status_wrap {
    padding: 10px 16px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > div {
        span {
            display: inline-block;
            vertical-align: top;
            width: 68px;
            height: 26px;
            text-align: center;
            line-height: 26px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(102, 102, 102, 1);
            border-radius: 4px;
            background: rgba(255, 255, 255, 1);

            & + span {
                margin-left: 10px;
            }

            &.active {
                color: rgba(41, 144, 255, 1);
                border: 1px solid rgba(41, 144, 255, 0.5);
                background: rgba(41, 144, 255, 0.1);
            }
        }
    }

    & > span {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }
}

.payable_management_container {
    .mobile_container_list {
        padding: 0 16px 8px;

        .payable_list_item {
            width: 100%;
            padding: 12px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 8px;

            .payable_list_item_top {
                padding-bottom: 12px;
                display: flex;
                align-items: center;
                position: relative;

                & > span {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);
                }

                .link-label {
                    color: rgba(41, 144, 255, 1);
                }

                .payable_list_item_status {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 64px;
                    height: 22px;
                    text-align: center;
                    line-height: 22px;
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    border-radius: 4px;

                    &.payable_list_item_status1 {
                        color: rgba(240, 170, 50, 1);
                        background: rgba(240, 170, 50, 0.15);
                    }

                    &.payable_list_item_status4 {
                        color: rgba(247, 187, 152, 1);
                        background-color: rgba(247, 187, 152, 0.15);
                    }

                    &.payable_list_item_status2 {
                        color: rgba(90, 179, 51, 1);
                        background-color: rgba(90, 179, 51, 0.15);
                    }

                    &.payable_list_item_status3 {
                        color: rgba(153, 153, 153, 1);
                        background-color: rgba(153, 153, 153, 0.15);
                    }
                }
            }

            .payable_list_item_content {
                p {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);
                    margin-bottom: 4px;

                    .link-label {
                        color: rgba(41, 144, 255, 1);
                    }
                }

                .payable_list_item_amount {
                    width: 100%;
                    padding: 4px;
                    border-radius: 4px;
                    background: #ffffff;
                    border: 2px solid rgba(237, 240, 244, 1);

                    & > div {
                        height: 24px;
                        display: flex;
                        justify-content: space-between;
                        gap: 4px;
                    }

                    & > div + div {
                        margin-top: 4px;
                    }

                    .payable_list_item_amount_percent {
                        width: 100%;
                        height: 24px;
                        padding: 0 8px;
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 24px;
                        color: rgba(102, 102, 102, 1);
                        border-radius: 4px;
                        box-sizing: border-box;
                    }

                    .percent_bg1 {
                        background-color: rgba(41, 144, 255, 0.16);
                    }

                    .percent_bg2 {
                        background-color: rgba(41, 144, 255, 0.08);
                        padding-right: 0;
                    }

                    .percent_bg3 {
                        background-color: rgba(0, 0, 0, 0.04);
                        color: rgba(51, 51, 51, 1);
                        font-weight: 700;
                        text-align: right;
                        padding-left: 0;
                    }
                }
            }

            .payable_list_item_bottom {
                margin-top: 10px;
                display: flex;
                justify-content: flex-end;

                .van-button {
                    padding: 0 7px;
                    border-radius: 4px;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
